class ViewportObserver {
  constructor(options) {
    this.callback = options.callback
    // Bind event handlers to class instance
    this.onElementVisible = this.onElementVisible.bind(this)
    this.onIntersectionChange = this.onIntersectionChange.bind(this)
    this.onPageFullyLoaded = this.onPageFullyLoaded.bind(this)
    // Initialize instance state
    this.elements = new WeakMap()
    this.deferVisible = new Set()
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Intersection_observer_options
    this.observer = new IntersectionObserver(
      this.onIntersectionChange,
      options.intersectionObserverOptions
    )
    this.isDeferred = document.readyState !== 'complete'
    // Wait for page load completion before marking elements as visible
    if (this.isDeferred) {
      window.addEventListener('load', this.onPageFullyLoaded)
    }
  }

  // API

  observe(domElement, reactElement) {
    this.elements.set(domElement, reactElement)
    this.observer.observe(domElement)
  }

  unobserve(domElement) {
    this.observer.unobserve(domElement)
    this.elements.delete(domElement)
    this.deferVisible.delete(domElement)
  }

  // Event handlers

  onPageFullyLoaded() {
    // Flush the deferred visible elements
    this.deferVisible.forEach(this.onElementVisible)
    this.deferVisible.clear()
    // Stop listening for page load
    this.isDeferred = false
    window.removeEventListener('load', this.onPageFullyLoaded)
  }

  onIntersectionChange(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (this.isDeferred) {
          this.deferVisible.add(entry.target)
        } else {
          this.onElementVisible(entry.target)
        }
      }
    })
  }

  onElementVisible(domElement) {
    if (this.elements.has(domElement)) {
      const reactElement = this.elements.get(domElement)
      this.callback(domElement, reactElement)
    }
    this.unobserve(domElement)
  }
}

module.exports = ViewportObserver
